import script from "./HeadCom.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeadCom.vue?vue&type=script&lang=ts&setup=true"

import "./HeadCom.vue?vue&type=style&index=0&id=1d2fbb60&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d2fbb60"]])

export default __exports__